<template>
  <b-modal
    id="modal-edit"
    ref="my-edit"
    cancel-variant="outline-secondary"
    ok-title="Save"
    :title="$t('DEBTIA_EDIT_CASE_REASON_TITLE')"
    cancel-title="Close"
    centered
    size="md"
    @ok.prevent="HandleEditCase"
    @close="handleClose"
    @hide="handleClose"
  >
    <b-overlay
      id="overlay-background"
      :show="loader"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <Validation-observer ref="EditCaseRules">
        <b-form @submit.prevent>
          <b-row>
            <b-col>
              <b-form-group
                class="mb-2"
                :label="$t('DEBTIA_CASE_REASON_TITLE')"
                label-for="case-reason-title"
              >
                <validation-provider
                  #default="{ errors }"
                  name="case reason"
                  rules="required"
                >
                  <b-form-input
                    v-model="caseReasonDetails.title"
                    @keyup.enter="HandleEditCase"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>

    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BRow, BCol, BForm, BFormGroup, BFormInput, BOverlay, BModal,
} from 'bootstrap-vue'
import axios from '@axios'
import i18n from '@/libs/i18n'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import constants from '@/app-configs/constants'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'AddCaseReasons',
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    BModal,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    editCase: {
      type: Object,
      default: () => ({}),
    },
    reloadMethod: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loader: false,
      title: '',
      caseReasonDetails: {},
      required,
    }
  },
  watch: {
    editCase: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.caseReasonDetails = { ...newVal }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    HandleEditCase() {
      this.loader = true

      this.$refs.EditCaseRules.validate().then(success => {
        if (!success) {
          this.loader = false
          return
        }

        const url = `${constants.baseUrl}/reasons/update/${this.caseReasonDetails.id}`
        axios.post(url, { title: this.caseReasonDetails.title }).then(response => {
          if (response.status === 200) {
            this.loader = false
            this.$refs['my-edit'].hide()
            this.reloadMethod()
            this.$swal({
              icon: 'success',
              title: i18n.t('DEBTIA_SUCCESS'),
              text: i18n.t('DEBTIA_CASE_REASON_UPDATE_SWAL'),
              customClass: {
                confirmButton: 'btn btn-primary',
              },
            })
          }
        }).catch(error => {
          this.loader = false
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              icon: 'CoffeeIcon',
              variant: 'danger',
              text: error.response.data.message[0],
            },
          })
        })
      })
    },
    handleClose(evt) {
      if (evt.trigger !== 'ok') {
        this.resetModal()
      }
    },
    resetModal() {
      this.caseReasonDetails.title = this.editCase.title
    },
  },
}
</script>
